import styled from "styled-components";
import Form from "react-bootstrap/Form";

export const FormGroupStyled = styled(Form)`
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 578px;
    gap: 15px;

    @media(max-width: 1366px){
        width: 100%;
        padding: 0 10%;
    }
`

export const DivSubmit = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: end;
    margin-top: 40px;
`;